// THEME
// Para ver y generar paleta de colores ir a https://www.w3schools.com/w3css/w3css_color_generator.asp
// luego ingresar el valor de TH (por ejemplo: #d20000) y presionar el botón Create Theme
const Themes = [
        {
                L5: '#f2fcff',
                L4: '#d4f4ff',
                L3: '#aae9ff',
                L2: '#7fdffe',
                L1: '#54d4fe',
                TH: '#2cc9fe',
                D1: '#0cc1fe',
                D2: '#01b1eb',
                D3: '#019bce',
                D4: '#0185b1',
                D5: '#016f93'
        },        
        {
                L5: '#edfcff',
                L4: '#c4f5ff',
                L3: '#89ebff',
                L2: '#4ee1ff',
                L1: '#12d8ff',
                TH: '#00b4d8',
                D1: '#00a1c1',
                D2: '#008fab',
                D3: '#007d96',
                D4: '#006b81',
                D5: '#00596b'
        },
        {
                L5: '#f6fdfd',
                L4: '#e0f9f9',
                L3: '#c0f2f2',
                L2: '#a1ecec',
                L1: '#82e5e5',
                TH: '#64dfdf',
                D1: '#48d9d9',
                D2: '#2dd4d4',
                D3: '#26bbbb',
                D4: '#21a0a0',
                D5: '#1b8585'
        },
        {
                L5: '#eeffff',
                L4: '#c8fffe',
                L3: '#91fffd',
                L2: '#5afffc',
                L1: '#23fffb',
                TH: '#00ebe7',
                D1: '#00d3d0',
                D2: '#00bcb9',
                D3: '#00a4a1',
                D4: '#008d8a',
                D5: '#007573'
        },
        {
                L5: '#f6ffff',
                L4: '#e0ffff',
                L3: '#c2ffff',
                L2: '#a3ffff',
                L1: '#85ffff',
                TH: '#66ffff',
                D1: '#42ffff',
                D2: '#1fffff',
                D3: '#00fafa',
                D4: '#00d6d6',
                D5: '#00b3b3'
        },
        {
                L5: '#f0fdff',
                L4: '#ccf7ff',
                L3: '#99f0ff',
                L2: '#66e8ff',
                L1: '#33e0ff',
                TH: '#00d7ff',
                D1: '#00c3e6',
                D2: '#00adcc',
                D3: '#0098b3',
                D4: '#008299',
                D5: '#006c80'
        },        
        {
                L5: '#f4fbff',
                L4: '#daf0ff',
                L3: '#b6e2ff',
                L2: '#91d3ff',
                L1: '#6cc4ff',
                TH: '#47b6ff',
                D1: '#27a9ff',
                D2: '#069bff',
                D3: '#0089e4',
                D4: '#0076c4',
                D5: '#0062a3'
        },              
        {
                L5: "#edf8ff",
                L4: "#c2e7ff",
                L3: "#85ceff",
                L2: "#47b6ff",
                L1: "#0a9dff",
                TH: "#007acc",
                D1: "#006eb8",
                D2: "#0062a3",
                D3: "#00568f",
                D4: "#00497a",
                D5: "#003d66"
        },
        {
                L5: "#ffeded",
                L4: "#ffc3c3",
                L3: "#ff8787",
                L2: "#ff4a4a",
                L1: "#ff0e0e",
                TH: "#d20000",
                D1: "#bc0000",
                D2: "#a70000",
                D3: "#920000",
                D4: "#7d0000",
                D5: "#690000"
        },
        {
                L5: "#fff0f0",
                L4: "#ffcccc", 
                L3: "#ff9999", 
                L2: "#ff6666",
                L1: "#ff3333",
                TH: "#ff0000",
                D1: "#e60000",
                D2: "#cc0000",
                D3: "#b30000",
                D4: "#990000",
                D5: "#800000"
        },
        {
                L5: "#fff0f4",
                L4: "#ffccd9",
                L3: "#ff99b3",
                L2: "#ff668c",
                L1: "#ff3366",
                TH: "#ff0040",
                D1: "#e60039",
                D2: "#cc0033",
                D3: "#b3002d",
                D4: "#990026",
                D5: "#800020"
        },
        {
                L5: "#f8f8f8",
                L4: "#e8e7e7",
                L3: "#d1d0d0",
                L2: "#b9b8b8",
                L1: "#a2a0a0",
                TH: "#8a8888",
                D1: "#7d7b7b",
                D2: "#6f6d6d",
                D3: "#615f5f",
                D4: "#535252",
                D5: "#464444"
        }
];
export default Themes;
